import styled, { css } from 'styled-components';
import arrowDown from '~/assets/icons/arrow_down.svg';
import cross from '~/assets/icons/cross.svg';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
`;

const StyledArrowDown = styled.img.attrs({
	src: arrowDown,
	width: 14,
	height: 14,
})<{ $active?: boolean }>`
	rotate: ${(props) => props.$active && '180deg'};
	transform-origin: center;
	transition:
		opacity 0.3s ease,
		rotate 0.3s ease;
	user-select: none;
	pointer-events: none;
`;

const StyledTopContainer = styled.div<{
	$focus?: boolean;
	$active?: boolean;
}>`
	position: relative;
	z-index: ${(props) => (props.$focus ? 4 : 2)};
	display: grid;
	grid-template-columns: 14px 1fr 14px;
	gap: 10px;
	align-items: center;
	height: 40px;
	padding: 0 10px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.25);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		color: #ffffff;
		font-size: 14px;
		font-weight: 400;
	}

	${(props) =>
		!props.$active &&
		css`
			&:hover {
				background-color: rgba(255, 255, 255, 0.1);

				${Text} {
					color: #000000;
				}
			}
		`}

	${(props) =>
		props.$focus &&
		!props.$active &&
		css`
			background-color: rgba(255, 255, 255, 0.1);

			${Text} {
				color: #000000;
			}
		`}


	${(props) =>
		props.$active &&
		css`
			background-color: rgba(255, 50, 50, 0.5);
			border: 1px solid rgba(255, 50, 50, 1);
		`}
`;

const StyledCross = styled.img.attrs({
	src: cross,
	width: 14,
	height: 14,
})`
	position: absolute;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	cursor: pointer;
	user-select: none;
`;

const StyledDropdownContainer = styled.div`
	position: absolute;
	top: calc(100% + 10px);
	width: 100%;
	z-index: 4;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.results-enter {
		opacity: 0;
	}

	&.results-enter-active,
	&.results-enter-done,
	&.results-exit {
		opacity: 1;
	}

	&.results-exit-active {
		opacity: 0;
	}
`;

const StyledItemsContainer = styled.div`
	width: 100%;
	max-height: 400px;
	display: flex;
	flex-direction: column;
	background-color: rgba(255, 255, 255, 0.95);
	overflow-y: auto;
	z-index: 4;
	border-radius: 10px;

	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: transparent;
		transition: background-color 0.3s ease;

		&:hover {
			background-color: rgba(0, 0, 0, 1);
		}
	}
`;

const StyledSelectItem = styled.div`
	padding: 20px 0;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);

	${Text} {
		color: #000000;
		font-size: 16px;
		font-weight: 400;

		span {
			opacity: 0.5;
		}
	}
`;

const StyledSelectItemWrapper = styled.div<{
	$disabled?: boolean;
	$scrollbar?: boolean;
	$active?: boolean;
}>`
	padding: 0 10px;
	background-color: transparent;
	transition: background-color 0.3s ease;

	${(props) =>
		props.$active &&
		css`
			background-color: #2d70da;

			${StyledSelectItem} {
				${Text} {
					color: #ffffff;
				}
			}
		`}

	${(props) =>
		!props.$disabled &&
		css`
			&:hover {
				background-color: #000000;

				${StyledSelectItem} {
					${Text} {
						color: #ffffff;
					}
				}
			}
		`}

	${(props) =>
		!props.$disabled &&
		css`
			&,
			& * {
				cursor: pointer;
			}
		`}
`;

export {
	StyledArrowDown,
	StyledContainer,
	StyledCross,
	StyledDropdownContainer,
	StyledItemsContainer,
	StyledSelectItem,
	StyledSelectItemWrapper,
	StyledTopContainer,
};
